import { useQuery } from 'react-query'
import { PaginatedRequest } from '../../../core/interfaces'
import { getOpportunityConcepts } from '../../opportunities'

export default function useOpportunityConcepts(query: PaginatedRequest<any>) {
  const { data, error, isLoading } = useQuery(
    ['opportunityConcepts', query],
    () => getOpportunityConcepts(query)
  )
  return { data, error, isLoading }
}
